import $ from 'jquery'
import * as WebFont from 'webfontloader'

const soundsPath = '//www.rphaven.com/sounds/',
	$settingsStyle = $( '<style type="text/css"></style>' ).appendTo( 'head' ),

	rph = {
		dialogs: {},
		unreadPms: 0,
		pinged: false,
		alerted: false,
		version: 1625612299999,
		sounds: {
			im: new Audio( soundsPath + 'imsound.mp3' ),
			notify: new Audio( soundsPath + 'boop.mp3' ),
			squawk: new Audio( soundsPath + 'boopChocobo.mp3' ),
			wave: new Audio( soundsPath + 'chatsound.mp3' )
		}
	},
	handlers = {
		'imVolume': ( value ) => {
			rph.sounds.im.volume = value
		},
		'pingVolume': ( value ) => {
			rph.sounds.notify.volume = value
		},
		'msgDivider': ( value ) => {
			value === true
				? $( 'body' ).removeClass( 'hide-divider' )
				: $( 'body' ).addClass( 'hide-divider' )
		},
		'fontSize': ( value ) => {
			$( 'body' ).css( 'font-size', value + 'rem' )
		},
		'expand': ( value ) => {
			if( value === true ){
				$( '#open-friends' ).click()
			}
		},
		'font': ( value ) => {
			WebFont.load({
				google: { families: [value] },
				timeout: 5000
			})
			$( 'body' ).css( 'font-family', value + ', sans-serif' )
		},
		'fontWeight': ( value ) => {
			$( 'body' ).css( 'font-weight', value )
			$settingsStyle.text( '.name, .name:hover {font-weight: ' + ( value + 200 ) + ';}' )
		},
		'theme': ( value ) => {
			console.log( 'handle setting theme', value )
			import( /* webpackChunkName: "settings" */ './settings.js' ).then( ( module ) => {
				const settings = module.default

				if( !settings.customTheme ){
					$( '#theme' ).attr( 'href', '//www.rphaven.com/css/' + value.toLowerCase() + '-theme.css?' + rph.version )
				}
			})
		},
		'customTheme': ( value ) => {
			import( /* webpackChunkName: "settings" */ './settings.js' ).then( ( module ) => {
				const settings = module.default

				if( value ){
					$( '#theme' ).attr( 'href', value )
				} else {
					$( '#theme' ).attr( 'href', 'css/' + settings.theme.toLowerCase() + '-theme.css?' + rph.version )
				}
			})
		}
	}
rph.handleSetting = ( key, value ) => {
	handlers[key] && handlers[key]( value )
}

rph.sounds.squawk.volume = 0.28

export default rph
